class ImageField {
  constructor(element) {
    this.element = element;
    this.field = element.find("input");
    this.image = element.find("img");

    this.field.change((e) => {
      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          this.image.attr("src", e.target.result);
        }.bind(this);

        reader.readAsDataURL(e.target.files[0]);
      }
    });
  }
}

$(document).on("turbo:load", () => {
  $("[data-behavior=image-field").each(function () {
    new ImageField($(this));
  });
});
